import { ConfirmRemoveAllMenuItem } from '@/modules/dispositiveProvisions/DispositiveProvisionsFormV2/components/contextMenu/shared/ConfirmRemoveAllMenuItem';

interface RemoveAllBeneficiariesMenuItemProps {
  tier: 'primary' | 'contingent';
  hasRecipients: boolean;
  onRemoveAll: () => void;
}

export function RemoveAllBeneficiariesMenuItem({
  tier,
  hasRecipients,
  onRemoveAll,
}: RemoveAllBeneficiariesMenuItemProps) {
  if (!hasRecipients) {
    return null;
  }

  return (
    <ConfirmRemoveAllMenuItem
      menuItemLabel={`Remove all ${tier} beneficiaries`}
      confirmHeading={`Remove all ${tier} beneficiaries`}
      confirmBody={`All ${tier} beneficiaries will be removed.`}
      onConfirm={onRemoveAll}
    />
  );
}
